import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51d29a20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-xxl-7 col-xl-8 col-lg-11 col-md-12 mx-auto p-0 my-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold fs-1 text-center py-3 px-3" }, "Explora las mejores marcas", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1))
const _hoisted_4 = { class: "col-12 p-5" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "row align-items-center" }
const _hoisted_8 = { class: "col-md-4 col-12 d-flex align-items-center justify-content-center" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "col-8 d-none d-md-block" }
const _hoisted_11 = { class: "mb-1 fs-5" }
const _hoisted_12 = { class: "mb-0 fs-sm" }
const _hoisted_13 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.brands, (brand, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-md-6 col-lg-4 col-6 mx-auto my-2 my-md-4 d-flex align-items-center",
            key: index
          }, [
            _createElementVNode("div", {
              onClick: ($event: any) => ($setup.sendQuery(brand.name)),
              class: "card border border-secondary w-100 py-5 px-5 px-lg-8 pointer"
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("img", {
                    src: `/media/images/brands/${brand.logo}`,
                    class: "img-fluid h-45px",
                    alt: brand.name
                  }, null, 8, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, _toDisplayString(brand.name), 1),
                  _createElementVNode("p", _hoisted_12, "Desde " + _toDisplayString(brand.minPrice) + " mil", 1)
                ])
              ])
            ], 8, _hoisted_6)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_router_link, {
          to: "/catalogo",
          class: "fs-5 link-blue text-center"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Explora todo el catálogo ")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}